import { BailleursParticipantSex } from 'common-app/types/bailleurs-participant';
import { ConsentsRelatedTextRole, ConsentsStatus, ParameterState, ParameterType, } from '@isyc-react/types';
let id = 1;
export const generateId = () => id++;
const createOccupantParameters = () => [
    { label: 'Handicap', code: 'handicap', parameterType: ParameterType.BOOLEAN_TYPE },
    { label: 'Code CSP', code: 'code_csp' },
    { label: 'Code nature contrat travail', code: 'code_nature_contrat_travail' },
    { label: 'Lien parente', code: 'lien_parente' },
    { label: 'A charge', code: 'acharge', parameterType: ParameterType.BOOLEAN_TYPE },
    { label: 'Garde alternee', code: 'garde_alternee' },
    { label: 'Droite de visite', code: 'droite_de_visite' },
    { label: 'Nature', code: 'nature' },
    { label: 'Occupant Prestations', code: 'occupant_prestations' },
    { label: 'Occupant Ressources', code: 'occupant_ressources' },
    { label: 'Toujours', code: 'toujours_dans_logement' },
    { label: 'paysnaiss', code: 'paysnaiss' },
].map(p => (Object.assign(Object.assign({ id: generateId(), parameterId: generateId(), state: ParameterState.NO_VALIDATION, parameterType: ParameterType.STRING_TYPE, groupId: generateId(), groupName: 'Occupant', remarks: '', value: '', obligatory: false, editable: true, verificable: false, auditable: false, repeatable: false, relatedObjectName: '', comboCodeLabel: '', decimalFormat: '', relatedObjectType: 0, childrenParameters: [] }, p), { __typename: 'ParameterDto' })));
const createSignatureParameters = () => [
    { label: 'Handicap', code: 'handicap', parameterType: ParameterType.BOOLEAN_TYPE },
    { label: 'Code situation Familiale', code: 'code_situation_familiale' },
    { label: 'Date situation Familiale', code: 'date_situation_familiale', parameterType: ParameterType.DATE_TYPE },
    { label: 'Code nationalité', code: 'code_nationalite' },
    { label: "Nombre d'enfants à charge", code: 'nb_enfant_a_charge', parameterType: ParameterType.INTEGER_TYPE },
    {
        label: "Nombre d'autres personnes à charge",
        code: 'nb_autre_pers_a_charge',
        parameterType: ParameterType.INTEGER_TYPE,
    },
    { label: 'Nombre de parts fiscales', code: 'nb_part_fiscales', parameterType: ParameterType.INTEGER_TYPE },
    { label: 'Code nature contrat travail', code: 'code_nature_contrat_travail' },
    { label: 'Code CSP', code: 'code_csp' },
    { label: 'Parti le', code: 'parti_le', parameterType: ParameterType.DATE_TYPE },
    { label: 'Nature', code: 'nature' },
    { label: 'Imposable', code: 'imposable' },
    { label: 'Prestations sociales perçues', code: 'Individu_Prestations' },
    { label: 'Ressources perçues', code: 'Individu_Ressources' },
    { label: 'Code', code: 'code' },
    { label: 'Toujours', code: 'toujours_dans_logement' },
    { label: 'paysnaiss', code: 'paysnaiss' },
].map(p => (Object.assign(Object.assign({ id: generateId(), parameterId: generateId(), state: ParameterState.NO_VALIDATION, parameterType: ParameterType.STRING_TYPE, groupId: generateId(), groupName: 'Occupant', remarks: '', value: '', obligatory: false, editable: true, verificable: false, auditable: false, repeatable: false, relatedObjectName: '', comboCodeLabel: '', decimalFormat: '', relatedObjectType: 0, childrenParameters: [] }, p), { __typename: 'ParameterDto' })));
let mainSignatory = {
    id: generateId(),
    erasable: false,
    sex: BailleursParticipantSex.FEMALE,
    birthName: 'Main Signatory Birth Name',
    firstname: 'Main Signatory First Name',
    surname: 'Main Signatory Surname',
    birthDate: new Date().toISOString(),
    mail: 'main_signatory_mail@isyc.com',
    personalPhone: {
        prefix: '+33',
        number: '666666666',
    },
    mobilePhone: {
        prefix: '+33',
        number: '666666666',
    },
    parameters: createSignatureParameters(),
};
const updateParams = (oldParams = [], currentParams = []) => {
    const newParams = [...oldParams];
    currentParams.forEach(param => {
        const oldParam = newParams.find(p => p.id === param.id);
        if (oldParam)
            oldParam.value = param.value;
    });
    return newParams;
};
const updateSignatory = (oldSignatory, newSignatory) => {
    const newParams = updateParams(oldSignatory.parameters, newSignatory.parameters);
    const newSign = Object.assign(Object.assign(Object.assign({}, oldSignatory), newSignatory), { parameters: newParams });
    return newSign;
};
export const getMainSignatory = () => mainSignatory;
export const setMainSignatory = (participant) => {
    const newMain = updateSignatory(mainSignatory, participant);
    mainSignatory = newMain;
    return newMain;
};
let signatory = [
    {
        id: generateId(),
        sex: BailleursParticipantSex.MALE,
        erasable: false,
        birthName: 'Signatory Birth Name',
        firstname: 'Signatory First Name',
        surname: 'Signatory Surname',
        birthDate: new Date().toISOString(),
        mail: 'signatory_mail@isyc.com',
        personalPhone: {
            prefix: '+33',
            number: '666666666',
        },
        mobilePhone: {
            prefix: '+33',
            number: '666666666',
        },
        parameters: createSignatureParameters(),
    },
];
export const newSignatory = () => {
    return {
        id: generateId(),
        erasable: true,
        sex: null,
        birthName: '',
        firstname: '',
        surname: '',
        birthDate: '',
        mail: '',
        personalPhone: null,
        mobilePhone: null,
        parameters: createSignatureParameters(),
    };
};
export const getSignatory = () => signatory;
// TODO find if exists in signatory and propagate the old fields ... mostly in parameters :), same in occupant and main
export const setSignatory = (participant) => {
    const newSignatories = [...participant].map((p) => {
        var _a, _b;
        const newSignatory = Object.assign(Object.assign({}, p), { id: (_a = p.id) !== null && _a !== void 0 ? _a : generateId(), erasable: (_b = p.erasable) !== null && _b !== void 0 ? _b : true });
        const oldSignatory = signatory.find(s => s.id === p.id);
        if (oldSignatory) {
            return updateSignatory(oldSignatory, newSignatory);
        }
        else {
            return Object.assign(Object.assign({}, newSignatory), { parameters: updateParams(createSignatureParameters(), newSignatory.parameters) });
        }
    });
    signatory = newSignatories;
};
let occupant = [
    {
        id: generateId(),
        erasable: false,
        sex: BailleursParticipantSex.FEMALE,
        birthName: 'Occupant Birth Name',
        firstname: 'Occupant First Name',
        surname: 'Occupant Surname',
        birthDate: new Date().toISOString(),
        parameters: createOccupantParameters(),
    },
];
export const newOccupant = () => {
    return {
        id: generateId(),
        erasable: true,
        sex: null,
        birthName: '',
        firstname: '',
        surname: '',
        birthDate: '',
        parameters: createOccupantParameters(),
    };
};
export const getOccupant = () => occupant;
export const setOccupant = (participant) => {
    occupant = participant.map((p) => { var _a, _b; return (Object.assign(Object.assign({}, p), { id: (_a = p.id) !== null && _a !== void 0 ? _a : generateId(), erasable: (_b = p.erasable) !== null && _b !== void 0 ? _b : true })); });
};
// TODO delete ... below
let parameters = {};
export const getParameters = (idObject) => {
    var _a;
    return (_a = parameters[idObject]) !== null && _a !== void 0 ? _a : createParameters(idObject);
};
const createParameters = (idObject) => {
    if ([mainSignatory, ...signatory].find(p => p.id === idObject)) {
        const params = createSignatureParameters();
        parameters[idObject] = params;
    }
    else if (occupant.find(p => p.id === idObject)) {
        const params = createOccupantParameters();
        parameters[idObject] = params;
    }
    return parameters[idObject];
};
export const setParameters = (idObject, params) => {
    parameters[idObject] = params;
};
// TODO delete ... up
let consentsGroup = [
    {
        name: 'Test Consents Group',
        statusTree: {
            treelevel1: '1',
            treelevel2: '',
            treelevel3: '',
            treelevel4: '',
        },
        consentsGroupTemplate: {
            name: 'Consent group template name',
            code: 'TST_GROUP',
            id: 22332,
            consentsTemplates: [],
        },
        id: 98765,
        __typename: 'ConsentsGroupDTO',
        consents: [
            {
                __typename: 'ConsentsDTO',
                related_archive: [],
                related_text: [
                    {
                        __typename: 'TextRelatedDto',
                        role: ConsentsRelatedTextRole.HTML,
                        situation: 0,
                        textDto: {
                            id: 112,
                            name: 'Text test 0',
                            creationTimestamp: '',
                            businessUnitId: 1091,
                            businessUnitCodename: 'BUTEST',
                            status: 0,
                            textTemplate: null,
                            text: '<h1 class="font-size-30 font-size-lg-40 text-darker-primary text-center fw-700 mb-0">VOTRE ENQUÊTE RESSOURCES SLS</h1><h2 class="font-size-30  font-size-lg-40 text-darker-primary text-center fw-600">SLS <span class="font-size-30">(Supplément de Loyer de Solidarité)</span></h2><div class="consentement"><h3 class="text-center text-darker-primary font-size-20 fw-600">TEXTE CONSENTEMENT</h3><p class="text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam leo ligula, interdum in blandit non, dignissim vitae lectus. Nam et dictum tortor. Integer vehicula, metus id tristique volutpat, risus odio laoreet urna, eu egestas sapien justo vel massa.</p><div class="form-check mx-auto d-flex justify-content-center my-5"><input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked><label class="form-check-label" for="flexCheckChecked">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</label></div></div>',
                            relatedObjectTypeID: 0,
                            relatedID: 0,
                        },
                    },
                ],
                parameters: [],
                clientIp: '127.0.0.1',
                name: 'Consent test name',
                statusTree: {
                    treelevel1: '1',
                    treelevel2: '1.5',
                    treeLevel3: '',
                    treeLevel4: '',
                },
                consentsTemplate: {
                    parameterConfiguration: [],
                    name: 'Consent template name',
                    code: 'Consent template code',
                    id: 25001,
                },
                id: 10087,
                status: ConsentsStatus.NEW,
            },
        ],
    },
];
let dossier = {
    id: generateId(),
    step: null,
    name: 'Dossier Name',
    businessUnitId: generateId(),
    businessUnitName: 'Business Unit Name',
    dossierNumber: 'Dossier Number',
    consentsGroup: consentsGroup,
};
export const getDossier = () => dossier;
export const setStep = (step) => (dossier.step = step);
export const setConsentsGroupStatus = (id, status) => {
    // TODO update status for real? :)
    return consentsGroup;
};
